import React from 'react';
import { Form, Input, Select, Col, Row, Avatar, message, DatePicker, Modal, Tooltip, Upload, Icon, Tabs, Button } from 'antd';
import ModalDom from '../../../../components/Modal';
import TableDOM from '../../../../components/Table';
import DetailTitle from '../../../../components/DetailTitle';
import { CustomRow, CustomCol } from '../../../../components/Custom';
import { post, config, postFrom, uploadEnclosure } from '../../../../axios';
import { dicCustomerStatus, nation, gender, credentialType, authenticationStatus } from '../../../../axios/dictionaries';
import moment from 'moment';
import UploadFragment from './UploadFragment';
import Iconweixin from '../../../../style/imgs/icon-weixin.png';
import Iconeryaosu from '../../../../style/imgs/icon-eryaosu.png';
import Iconrenlian from '../../../../style/imgs/icon-renlian.png';
import Iconshiming from '../../../../style/imgs/icon-shiming.png';
import Iconzhengjian from '../../../../style/imgs/icon-zhengjian.png';
import { handleDeepCopy, formatTime } from '../../../../utils';
import FileUpload from '../../../../components/FileUpload';

const Option = Select.Option;
const { RangePicker } = DatePicker;
const { TextArea } = Input
const { TabPane } = Tabs

class Page extends React.Component {
    constructor() {
        super();
        this.initState = {
            customerType: 0,
            loading: false,
            data: {},
            showPrevImg: false,
            prevImg: '',
            merchantData: [], //商户列表

            apiLogData: { // logo数据
                total: 0,
                current: 1,
                list: []
            },
            detailVisible: false,
            detailData: {}
        };

        this.state = {
            ...handleDeepCopy(this.initState),
        }
    }

    componentDidMount() {
        this.props.onRef(this)
    }

    handleCancel = () => { //关闭页面
        this.setState({ ...handleDeepCopy(this.initState) }, () => {
            this.props.handleCancel();
        });
    }

    initUserType = (customerType) => { //初始化用户类型
        this.setState({ customerType });
    }

    initPack() {
        postFrom({
            url: config.API_merchant_findAll,
            data: {}
        }).then(res => {
            let merchantData = res.map(item => ({ title: item.shortName, value: item.id, name: item.name }));
            this.setState({ merchantData });
        }).catch(err => {
            message.error(err.message || '获取商户列表失败');
            this.setState({ loading: false });
        });
    }

    loadPack = ({ id }) => {
        this.setState({ loading: true, customerId:id});
        let data = { customerId: id };
        postFrom({ url: config.API_customer_getById, data }).then(res => {
            if (Array.isArray(res.attachList)) {
                res.attachList1 = res.attachList.filter(item => item.attachType === 1);
                res.attachList2 = res.attachList.filter(item => item.attachType === 2);
                res.attachList3 = res.attachList.filter(item => item.attachType === 3);
                res.attachList4 = res.attachList.filter(item => item.attachType === 4);
            }
            this.setState({ data: res, loading: false });
            this.fileUploadRef.setFileToState(res.attachList)
        }).catch(err => {
            message.error(err.message || '获取详情失败');
            this.setState({ loading: false });
        });
    }

    handleDeleteAttach = (type, index) => { //删除附件
        let data = this.state.data;
        data['attachList' + type].splice(index, 1);
        this.setState({ data });
    }

    uploadEnclosure = (type, name, fileData) => { //上传附件
        let data = this.state.data;
        if (type === 1) { // 营业执照           
            data.attachList1 = [fileData];
        } else if (type === 2) { // 正面照          
            data.attachList2 = [fileData];
        } else if (type === 3) { // 国徽照         
            data.attachList3 = [fileData];
        } else if (type === 4) { // 人脸照           
            if (Array.isArray(data.attachList4)) {
                data.attachList4.push(fileData);
            } else {
                data.attachList4 = [fileData];
            }
        }
        this.setState({ data });
    }

    handleOk = () => {
        this.props.form.validateFieldsAndScroll((error, values) => {
            if (!error) {
                let { customerType, data: { attachList1 = [], attachList2 = [], attachList3 = [], attachList4 = [] } } = this.state;
                if (customerType === 1) {
                    if ( (!Array.isArray(attachList1) || attachList1.length === 0) && values.credentialIdentified === 'true') {
                        message.error('请上传营业执照');
                        return
                    }
                } else if (customerType === 2) {
                    if ( (!Array.isArray(attachList2) || attachList2.length === 0) && values.credentialIdentified === 'true') {
                        message.error('请上传身份证正面照');
                        return
                    }
                    if ( (!Array.isArray(attachList3) || attachList3.length === 0) && values.credentialIdentified === 'true') {
                        message.error('请上传身份证国徽照');
                        return
                    }
                    if ( (!Array.isArray(attachList4) || attachList4.length === 0 ) && values.faceDetected === 'true' ) {
                        message.error('请上传人脸照');
                        return
                    }
                }
                this.setState({ loading: true });

                let attachList = [].concat(attachList1, attachList2, attachList3, attachList4);
                values.attachList = attachList.map((item, index) => {
                    return { id: item.attach_id || item.id }
                });

                const attach_14 = this.fileUploadRef.parseAttachToIds().map(e=>({id: e}))
                values.attachList = [...values.attachList, ...attach_14]

                //判断如果不存在赋值则默认为0
                if (!values.merchantId){
                    values.merchantId = 0; //不知道后台用来干吗的
                }

                if (!values.phone) { //针对企业用户，不需要填写电话，因此在此赋值为联系人电话
                    values.phone = values.linkmanPhone;
                }

                if (values.credentialIdentified === "true") //针对证件认证
                    values.credentialIdentified = true;
                else if (values.credentialIdentified === "false")
                    values.credentialIdentified = false;
                if (values.realNameIdentified === "true") //针对二要素认证
                    values.realNameIdentified = true;
                else if (values.realNameIdentified === "false")
                    values.realNameIdentified = false;
                if (values.faceDetected === "true") //人脸识别
                    values.faceDetected = true;
                else if (values.faceDetected === "false")
                    values.faceDetected = false;

                if (values.credentialValidDate) { //处理证件的有效期
                    values.credentialValidDate1 = values.credentialValidDate[0].format('YYYY-MM-DD');
                    values.credentialValidDate2 = values.credentialValidDate[1].format('YYYY-MM-DD');
                    delete values.credentialValidDate;
                }

                if (values.id) {
                    post({ url: config.API_customer_edit, data: values }).then(res => {
                        message.success('编辑成功');
                        this.props.handleGetList();
                        this.handleCancel();
                    }).catch(err => {
                        message.error(err.message || '编辑失败');
                        this.setState({ loading: false });
                    })
                } else {
                    post({ url: config.API_customer_create, data: values }).then(res => {
                        message.success('新增成功');
                        this.props.handleGetList();
                        this.handleCancel();
                    }).catch(err => {
                        message.error(err.message || '新增失败');
                        this.setState({ loading: false });
                    })
                }
            }
        })
    }

    renderApiLog = () => { // 接口日志渲染
        const apilogColumns = [
            { title: '接口名称', dataIndex: 'apiName' },
            { title: 'url', dataIndex: 'url' },
            {
                title: '调用时间', dataIndex: 'callTime',
                render(text) {
                    if (!text) return '-'
                    return formatTime(text)
                }
            },
        ]
        const { list, total, current } = this.state.apiLogData
        return (
            <TableDOM
                columns={apilogColumns}
                data={list}
                loading={false}
                total={total}
                current={current}
                onChange={this.postApilogFindPage}
                onRow={record => {
                    return {
                        onClick: event => { this.handleShowDetail(record) },
                    };
                }}
            />
        )
    }

    handleShowDetail = (record) => { // 打开详情
        this.setState({
            detailVisible: true,
            detailData: record
        })
    }

    handledetailCancel = () => { // 关闭详情
        this.setState({
            detailVisible: false
        })
    }

    postApilogFindPage = ({ id, current }) => { // 获取 apilog 记录
        const { apiLogData } = this.state
        const rowId = id || this.customerId
        this.customerId = rowId
        const data = { rowId, tableName: 'Customer', current: current || apiLogData.current, pageSize: 10 }
        postFrom({
            url: config.API_apilog_findPage,
            data,
        }).then(res => {
            const { current, total, records } = res
            this.setState({
                apiLogData: {
                    current,
                    total,
                    list: records
                }
            })
        }).catch(err => {
            message.error(err.message || '获取列表失败!')
        })
    }

    render() {
        let { visible, form: { getFieldDecorator, getFieldValue } } = this.props;
        let {
            customerType,
            loading,
            data,
            merchantData,
            detailData
        } = this.state;

        const formItemLayout = {
            labelCol: {
              xs: { span: 24 },
              sm: { span: 3 },
            },
            wrapperCol: {
              xs: { span: 24 },
              sm: { span: 20 },
            },
          };

        return <div>
            <ModalDom
                title={`${data.id ? '编辑' : '新增'}${customerType === 1 ? '企业用户' : customerType === 2 ? '个人用户' : ''}`}
                visible={visible}
                loading={loading}
                onOk={this.handleOk}
                onCancel={this.handleCancel}
            >
                <div className="custom">
                    <Form
                        labelCol={{ span: 0 }}
                        wrapperCol={{ span: 24 }}
                    >
                        {getFieldDecorator('id', {
                            initialValue: data.id
                        })(
                            <Input type={'hidden'} />
                        )}
                        {
                            // 企业
                            customerType === 1
                                ? <div>
                                    {getFieldDecorator('customerType', {
                                        initialValue: 1
                                    })(
                                        <Input type={'hidden'} />
                                    )}
                                    <CustomRow>
                                        <CustomCol label="企业名称" colStyle={{ width: '500px' }}>
                                            {getFieldDecorator('name', {
                                                rules: [{
                                                    required: true, message: '请输入',
                                                }],
                                                initialValue: data.name
                                            })(
                                                <Input
                                                    placeholder={'工商营业执照上的企业全称'}
                                                    autoComplete={'off'}
                                                />
                                            )}
                                        </CustomCol>
                                        <CustomCol label="证件号码" colStyle={{ width: '500px' }}>
                                            {getFieldDecorator('credentialNumber', {
                                                rules: [{
                                                    required: true, message: '请输入',
                                                }],
                                                initialValue: data.credentialNumber
                                            })(
                                                <Input
                                                    placeholder={'统一社会信用代码'}
                                                    autoComplete={'off'}
                                                    maxLength={20}
                                                />
                                            )}
                                        </CustomCol>
                                    </CustomRow>
                                    <CustomRow divider>
                                        <CustomCol required={false}  label="联系人">
                                            {getFieldDecorator('linkmanName', {
                                                // rules: [{
                                                //     required: true, message: '请输入',
                                                // }],
                                                initialValue: data.linkmanName
                                            })(
                                                <Input
                                                    placeholder={'请输入'}
                                                    autoComplete={'off'}
                                                    maxLength={10}
                                                />
                                            )}
                                        </CustomCol>
                                        <CustomCol required={false} label="手机号码">
                                            {getFieldDecorator('linkmanPhone', {
                                                // rules: [{
                                                //     required: true, message: '请输入',
                                                // }],
                                                initialValue: data.linkmanPhone
                                            })(
                                                <Input
                                                    placeholder={'请输入'}
                                                />
                                            )}
                                        </CustomCol>
                                    </CustomRow>
                                    <CustomRow divider>
                                        <CustomCol label="来源" required={false}>
                                            {getFieldDecorator('sourceType', {
                                                initialValue: 1
                                            })(
                                                <Select
                                                    showSearch
                                                    placeholder="请选择"
                                                    optionFilterProp={'children'}
                                                    disabled
                                                >
                                                    <Option value={1}>商户签约</Option>
                                                </Select>
                                            )}
                                        </CustomCol>
                                        <CustomCol label="渠道" required={false}>
                                            {getFieldDecorator('merchantId', {
                                                initialValue: data.merchantId!=null && data.merchantId>0 ? (data.merchantId+"") : undefined
                                            })(
                                                <Select
                                                    showSearch
                                                    placeholder="请选择"
                                                    optionFilterProp={'children'}
                                                >
                                                    {merchantData.map((item, index) => <Option value={String(item.value)} key={item.value} title={item.title}>{item.title}</Option>)}
                                                </Select>
                                            )}
                                        </CustomCol>
                                        <CustomCol label="使用状态">
                                            {getFieldDecorator('status', {
                                                rules: [{
                                                    required: true, message: '请选择',
                                                }],
                                                initialValue: data.status || 1
                                            })(
                                                <Select
                                                    showSearch
                                                    placeholder="请选择"
                                                    optionFilterProp={'children'}
                                                >
                                                    {dicCustomerStatus.map((item, index) => <Option key={index} value={item.value}>{item.title}</Option>)}
                                                </Select>
                                            )}
                                        </CustomCol>
                                    </CustomRow>
                                    {/* <DetailTitle title="认证信息" /> */}
                                    <Tabs defaultActiveKey="1">
                                        <TabPane tab="认证信息" key="1">
                                            <CustomRow>
                                                <CustomCol label="实名二要素">
                                                    {getFieldDecorator('realNameIdentified', {
                                                        rules: [{
                                                            required: true, message: '请选择',
                                                        }],
                                                        initialValue: data.realNameIdentified === undefined ? "false" : data.realNameIdentified.toString()
                                                    })(
                                                        <Select
                                                            showSearch
                                                            placeholder="请选择"
                                                            optionFilterProp={'children'}
                                                            disabled={data.realNameMode === 1 && data.realNameIdentified}
                                                        >
                                                            <Option value="true">已认证</Option>
                                                            <Option value="false">未认证</Option>
                                                        </Select>
                                                    )}
                                                </CustomCol>
                                                <CustomCol label="认证方式">
                                                    {getFieldDecorator('realNameMode', {
                                                        rules: [{
                                                            required: true, message: '请选择',
                                                        }],
                                                        initialValue: data.realNameMode || 2
                                                    })(
                                                        <Select
                                                            showSearch
                                                            placeholder="请选择"
                                                            optionFilterProp={'children'}
                                                            disabled
                                                        >
                                                            {authenticationStatus.map((item, index) => <Option value={item.value} key={item.value} title={item.title}>{item.title}</Option>)}
                                                        </Select>
                                                    )}
                                                </CustomCol>
                                            </CustomRow>
                                            <CustomRow divider>
                                                <CustomCol label="证件影像">
                                                    {getFieldDecorator('credentialIdentified', {
                                                        rules: [{
                                                            required: true, message: '请选择',
                                                        }],
                                                        initialValue: data.credentialIdentified === undefined ? "false" : data.credentialIdentified.toString()
                                                    })(
                                                        <Select
                                                            showSearch
                                                            placeholder="请选择"
                                                            optionFilterProp={'children'}
                                                            disabled={data.credentialMode === 1 && data.credentialIdentified}
                                                        >
                                                            <Option value="true">已认证</Option>
                                                            <Option value="false">未认证</Option>
                                                        </Select>
                                                    )}
                                                </CustomCol>
                                                <CustomCol label="认证方式">
                                                    {getFieldDecorator('credentialMode', {
                                                        rules: [{
                                                            required: true, message: '请选择',
                                                        }],
                                                        initialValue: data.credentialMode || 2
                                                    })(
                                                        <Select
                                                            showSearch
                                                            placeholder="请选择"
                                                            optionFilterProp={'children'}
                                                            disabled
                                                        >
                                                            {authenticationStatus.map((item, index) => <Option value={item.value} key={item.value} title={item.title}>{item.title}</Option>)}
                                                        </Select>
                                                    )}
                                                </CustomCol>
                                            </CustomRow>
                                            <Row style={{ width: '150px', marginRight: '150px' }}>
                                                {
                                                    Array.isArray(data.attachList1) && data.attachList1.length
                                                        ? <Col style={{ textAlign: 'center', marginTop: '15px' }}>
                                                            <UploadFragment
                                                                index={0}
                                                                preview={data.attachList1[0].attach_url || data.attachList1[0].fileUrl}
                                                                previewFn={(prevImg) => {
                                                                    this.setState({
                                                                        showPrevImg: true,
                                                                        prevImg
                                                                    })
                                                                }}
                                                                deleteFn={this.handleDeleteAttach.bind(this, 1)}
                                                                show={!(data.credentialMode === 1 && data.credentialIdentified)}
                                                                upload={<Upload {...uploadEnclosure({ accept: 'image/*', tableName: 'customer', success: this.uploadEnclosure.bind(this, 1), attachType: 1 })}>
                                                                    <span style={{ margin: '0 10px 0 0' }} className="showClickDetail">上传</span>
                                                                </Upload>}
                                                            />
                                                        </Col>
                                                        : data.credentialMode === 1 && data.credentialIdentified
                                                            ? null
                                                            : <Col style={{ textAlign: 'center', marginTop: '15px' }}>
                                                                <Upload {...uploadEnclosure({ accept: 'image/*', tableName: 'customer', success: this.uploadEnclosure.bind(this, 1), attachType: 1 })}>
                                                                    <div className="upload-box">
                                                                        <Icon type="plus" />
                                                                        <div className="ant-upload-text">营业执照</div>
                                                                    </div>
                                                                </Upload>
                                                            </Col>
                                                }
                                            </Row>
                                        </TabPane>
                                        <TabPane tab="接口日志" key="2">
                                            { this.renderApiLog() }
                                        </TabPane>
                                    </Tabs>
                                </div>
                                // 个人
                                : customerType === 2
                                    ? <div>
                                        {getFieldDecorator('customerType', {
                                            initialValue: 2
                                        })(
                                            <Input type={'hidden'} />
                                        )}
                                        <div style={{ textAlign: 'center', position: 'relative' }}>
                                            <div><Avatar size={60} src={data.weixinLogo ? data.weixinLogo : ""} icon={data.weixinLogo ? "" : "user"} /></div>
                                            <div style={{ margin: '10px auto 15px', textAlign: 'center' }}>
                                                {data.weixinOpenid ? <Tooltip placement="bottomLeft" arrowPointAtCenter title={"已关联微信"}><Avatar size={30} src={Iconweixin} /></Tooltip> : null}
                                                {data.realNameIdentified ? <Tooltip placement="bottomLeft" arrowPointAtCenter title={"已实名"}><Avatar size={30} src={Iconshiming} /></Tooltip> : null}
                                                {data.credentialIdentified ? <Tooltip placement="bottomLeft" arrowPointAtCenter title={"证件已认证"}><Avatar size={30} src={Iconzhengjian} /></Tooltip> : null}
                                                {data.realNameIdentified ? <Tooltip placement="bottomLeft" arrowPointAtCenter title={"二要素已认证"}><Avatar size={30} src={Iconeryaosu} /></Tooltip> : null}
                                                {data.faceDetected ? <Tooltip placement="bottomLeft" arrowPointAtCenter title={"已人脸识别"}><Avatar size={30} src={Iconrenlian} /></Tooltip> : null}
                                            </div>
                                        </div>
                                        <CustomRow>
                                            <CustomCol label="姓名">
                                                {getFieldDecorator('name', {
                                                    rules: [{
                                                        required: true, message: '请输入',
                                                    }],
                                                    initialValue: data.name
                                                })(
                                                    <Input
                                                        placeholder={'请输入'}
                                                        autoComplete={'off'}
                                                    />
                                                )}
                                            </CustomCol>
                                            <CustomCol label="证件类型">
                                                {getFieldDecorator('credentialType', {
                                                    rules: [{
                                                        required: true, message: '请选择',
                                                    }],
                                                    initialValue: data.credentialType || 1
                                                })(
                                                    <Select
                                                        showSearch
                                                        placeholder="请选择"
                                                        optionFilterProp={'children'}
                                                    >
                                                        {credentialType.map((item, index) => <Option key={index} value={item.value} title={item.title}>{item.title}</Option>)}
                                                    </Select>
                                                )}
                                            </CustomCol>
                                            <CustomCol label="证件号码：" >
                                                {getFieldDecorator('credentialNumber', {
                                                    rules: [{
                                                        required: true, message: '请输入',
                                                    }],
                                                    initialValue: data.credentialNumber
                                                })(
                                                    <Input
                                                        placeholder={'请输入'}
                                                        autoComplete={'off'}
                                                    />
                                                )}
                                            </CustomCol>
                                            <CustomCol label="手机号码">
                                                {getFieldDecorator('phone', {
                                                    rules: [{
                                                        required: true, message: '请输入',
                                                    }],
                                                    initialValue: data.phone
                                                })(
                                                    <Input
                                                        placeholder={'请输入'}
                                                        maxLength={11}
                                                        minLength={11}
                                                    />
                                                )}
                                            </CustomCol>
                                        </CustomRow>
                                        <CustomRow divider>
                                            <CustomCol required={false} label="联系人">
                                                {getFieldDecorator('linkmanName', {
                                                    // rules: [{
                                                    //     required: true, message: '请输入',
                                                    // }],
                                                    initialValue: data.linkmanName
                                                })(
                                                    <Input
                                                        placeholder={'请输入'}
                                                        autoComplete={'off'}
                                                        maxLength={10}
                                                    />
                                                )}
                                            </CustomCol>
                                            <CustomCol required={false} label="手机号码">
                                                {getFieldDecorator('linkmanPhone', {
                                                    // rules: [{
                                                    //     required: true, message: '请输入',
                                                    // }],
                                                    initialValue: data.linkmanPhone
                                                })(
                                                    <Input
                                                        placeholder={'请输入'}
                                                        maxLength={11}
                                                    />
                                                )}
                                            </CustomCol>
                                        </CustomRow>
                                        <CustomRow divider>
                                            <CustomCol label="来源" required={false}>
                                                {getFieldDecorator('sourceType', {
                                                    initialValue: 1
                                                })(
                                                    <Select
                                                        showSearch
                                                        placeholder="请选择"
                                                        optionFilterProp={'children'}
                                                        disabled
                                                    >
                                                        <Option value={1}>商户签约</Option>
                                                    </Select>
                                                )}
                                            </CustomCol>
                                            <CustomCol label="渠道" required={false}>
                                                {getFieldDecorator('merchantId', {
                                                    initialValue: data.merchantId!=null&&data.merchantId>0 ? (data.merchantId+"") : undefined
                                                })(
                                                    <Select
                                                        showSearch
                                                        placeholder="请选择"
                                                        optionFilterProp={'children'}
                                                    >
                                                        {merchantData.map((item, index) => <Option value={String(item.value)} key={item.value}>{item.title}</Option>)}
                                                    </Select>
                                                )}
                                            </CustomCol>
                                            <CustomCol label="使用状态">
                                                {getFieldDecorator('status', {
                                                    rules: [{
                                                        required: true, message: '请选择',
                                                    }],
                                                    initialValue: data.status || 1
                                                })(
                                                    <Select
                                                        showSearch
                                                        placeholder="请选择"
                                                        optionFilterProp={'children'}
                                                    >
                                                        {dicCustomerStatus.map((item, index) => <Option key={index} value={item.value}>{item.title}</Option>)}
                                                    </Select>
                                                )}
                                            </CustomCol>
                                        </CustomRow>
                                        <Tabs defaultActiveKey="3">
                                            <TabPane tab="认证信息" key="3">
                                                <CustomRow>
                                                    <CustomCol label="实名二要素">
                                                        {getFieldDecorator('realNameIdentified', {
                                                            rules: [{
                                                                required: true, message: '请选择',
                                                            }],
                                                            initialValue: data.realNameIdentified === undefined ? "false" : data.realNameIdentified.toString()
                                                        })(
                                                            <Select
                                                                showSearch
                                                                placeholder="请选择"
                                                                optionFilterProp={'children'}
                                                                disabled={data.realNameMode === 1 && data.realNameIdentified}
                                                            >
                                                                <Option value="true">已认证</Option>
                                                                <Option value="false">未认证</Option>
                                                            </Select>
                                                        )}
                                                    </CustomCol>
                                                    <CustomCol label="认证方式">
                                                        {getFieldDecorator('realNameMode', {
                                                            rules: [{
                                                                required: true, message: '请选择',
                                                            }],
                                                            initialValue: data.realNameMode || 2
                                                        })(
                                                            <Select
                                                                showSearch
                                                                placeholder="请选择"
                                                                optionFilterProp={'children'}
                                                                disabled
                                                            >
                                                                {authenticationStatus.map((item, index) => <Option value={item.value} key={item.value} title={item.title}>{item.title}</Option>)}
                                                            </Select>
                                                        )}
                                                    </CustomCol>
                                                </CustomRow>
                                                <CustomRow divider>
                                                    <CustomCol label="证件影像">
                                                        {getFieldDecorator('credentialIdentified', {
                                                            rules: [{
                                                                required: true, message: '请选择',
                                                            }],
                                                            initialValue: data.credentialIdentified === undefined ? "false" : data.credentialIdentified.toString()
                                                        })(
                                                            <Select
                                                                showSearch
                                                                placeholder="请选择"
                                                                optionFilterProp={'children'}
                                                                disabled={data.credentialMode === 1 && data.credentialIdentified}
                                                            >
                                                                <Option value="true">已认证</Option>
                                                                <Option value="false">未认证</Option>
                                                            </Select>
                                                        )}
                                                    </CustomCol>
                                                    <CustomCol label="认证方式">
                                                        {getFieldDecorator('credentialMode', {
                                                            rules: [{
                                                                required: true, message: '请选择',
                                                            }],
                                                            initialValue: data.credentialMode || 2
                                                        })(
                                                            <Select
                                                                showSearch
                                                                placeholder="请选择"
                                                                optionFilterProp={'children'}
                                                                disabled
                                                            >
                                                                {authenticationStatus.map((item, index) => <Option value={item.value} key={item.value} title={item.title}>{item.title}</Option>)}
                                                            </Select>
                                                        )}
                                                    </CustomCol>
                                                </CustomRow>
                                                <div style={{ display: 'flex' }}>
                                                    <Row style={{ width: '150px', marginRight: '150px' }}>
                                                        {
                                                            Array.isArray(data.attachList2) && data.attachList2.length
                                                                ? <Col style={{ textAlign: 'center', marginTop: '15px' }}>
                                                                    <UploadFragment
                                                                        index={0}
                                                                        preview={data.attachList2[0].attach_url || data.attachList2[0].fileUrl}
                                                                        previewFn={(prevImg) => {
                                                                            this.setState({
                                                                                showPrevImg: true,
                                                                                prevImg
                                                                            })
                                                                        }}
                                                                        deleteFn={this.handleDeleteAttach.bind(this, 2)}
                                                                        show={!(data.credentialMode === 1 && data.credentialIdentified)}
                                                                        upload={<Upload {...uploadEnclosure({ accept: 'image/*', tableName: 'customer', success: this.uploadEnclosure.bind(this, 2), attachType: 2 ,rowId:data.id||''})}>
                                                                            <span style={{ margin: '0 10px 0 0' }} className="showClickDetail">上传</span>
                                                                        </Upload>}
                                                                    />
                                                                </Col>
                                                                : data.credentialMode === 1 && data.credentialIdentified
                                                                    ? null
                                                                    : <Col style={{ textAlign: 'center', marginTop: '15px' }}>
                                                                        <Upload {...uploadEnclosure({ accept: 'image/*', tableName: 'customer', success: this.uploadEnclosure.bind(this, 2), attachType: 2,rowId:data.id||'' })}>
                                                                            <div className="upload-box">
                                                                                <Icon type="plus" />
                                                                                <div className="ant-upload-text">身份证正面照</div>
                                                                            </div>
                                                                        </Upload>
                                                                    </Col>
                                                        }
                                                        {
                                                            Array.isArray(data.attachList3) && data.attachList3.length
                                                                ? <Col style={{ textAlign: 'center', marginTop: '15px' }}>
                                                                    <UploadFragment
                                                                        index={0}
                                                                        preview={data.attachList3[0].attach_url || data.attachList3[0].fileUrl}
                                                                        previewFn={(prevImg) => {
                                                                            this.setState({
                                                                                showPrevImg: true,
                                                                                prevImg
                                                                            })
                                                                        }}
                                                                        deleteFn={this.handleDeleteAttach.bind(this, 3)}
                                                                        show={!(data.credentialMode === 1 && data.credentialIdentified)}
                                                                        upload={<Upload {...uploadEnclosure({ accept: 'image/*', tableName: 'customer', success: this.uploadEnclosure.bind(this, 3), attachType: 3 ,rowId:data.id||''})}>
                                                                            <span style={{ margin: '0 10px 0 0' }} className="showClickDetail">上传</span>
                                                                        </Upload>}
                                                                    />
                                                                </Col>
                                                                : data.credentialMode === 1 && data.credentialIdentified
                                                                    ? null
                                                                    : <Col style={{ textAlign: 'center', marginTop: '15px' }}>
                                                                        <Upload {...uploadEnclosure({ accept: 'image/*', tableName: 'customer', success: this.uploadEnclosure.bind(this, 3), attachType: 3,rowId:data.id||'' })}>
                                                                            <div className="upload-box">
                                                                                <Icon type="plus" />
                                                                                <div className="ant-upload-text">身份证国徽照</div>
                                                                            </div>
                                                                        </Upload>
                                                                    </Col>
                                                        }
                                                    </Row>
                                                    <div>
                                                        <CustomRow divider>
                                                            <CustomCol label="证件姓名" >
                                                                <Input
                                                                    value={getFieldValue('name')}
                                                                    disabled
                                                                />
                                                            </CustomCol>
                                                        </CustomRow>
                                                        <CustomRow divider>
                                                            <CustomCol label="证件号码" >
                                                                <Input
                                                                    value={getFieldValue('credentialNumber')}
                                                                    disabled
                                                                />
                                                            </CustomCol>
                                                        </CustomRow>
                                                        <CustomRow divider>
                                                            <CustomCol label="性别" required={getFieldValue('credentialIdentified') === 'true'}>
                                                                {getFieldDecorator('gender', {
                                                                    rules: [{
                                                                        required: getFieldValue('credentialIdentified') === 'true', message: '请选择',
                                                                    }],
                                                                    initialValue: data.gender || 1
                                                                })(
                                                                    <Select
                                                                        showSearch
                                                                        placeholder="请选择"
                                                                        optionFilterProp={'children'}
                                                                        disabled={data.credentialMode === 1 && data.credentialIdentified}
                                                                    >
                                                                        {gender.map((item, index) => <Option key={index} value={item.value}>{item.title}</Option>)}
                                                                    </Select>
                                                                )}
                                                            </CustomCol>
                                                        </CustomRow>
                                                        <CustomRow divider>
                                                            <CustomCol label="民族" required={getFieldValue('credentialIdentified') === 'true'}>
                                                                {getFieldDecorator('national', {
                                                                    rules: [{
                                                                        required: getFieldValue('credentialIdentified') === 'true', message: '请选择',
                                                                    }],
                                                                    initialValue: data.national || '汉'
                                                                })(
                                                                    <Select
                                                                        showSearch
                                                                        placeholder="请选择"
                                                                        optionFilterProp={'children'}
                                                                        disabled={data.credentialMode === 1 && data.credentialIdentified}
                                                                    >
                                                                        {nation.map((item, index) => <Option key={index} value={item.value}>{item.title}</Option>)}
                                                                    </Select>
                                                                )}
                                                            </CustomCol>
                                                        </CustomRow>
                                                        <CustomRow divider>
                                                            <CustomCol label="证件地址" colStyle={{ width: '500px' }} required={getFieldValue('credentialIdentified') === 'true'}>
                                                                {getFieldDecorator('credentialAddress', {
                                                                    rules: [{
                                                                        required: getFieldValue('credentialIdentified') === 'true', message: '请输入',
                                                                    }],
                                                                    initialValue: data.credentialAddress
                                                                })(
                                                                    <Input
                                                                        placeholder={'请输入'}
                                                                        autoComplete={'off'}
                                                                        disabled={data.credentialMode === 1 && data.credentialIdentified}
                                                                    />
                                                                )}
                                                            </CustomCol>
                                                        </CustomRow>
                                                        <CustomRow divider>
                                                            <CustomCol label="发证机关" colStyle={{ width: '500px' }} required={getFieldValue('credentialIdentified') === 'true'}>
                                                                {getFieldDecorator('credentialIssuedBy', {
                                                                    rules: [{
                                                                        required: getFieldValue('credentialIdentified') === 'true', message: '请输入',
                                                                    }],
                                                                    initialValue: data.credentialIssuedBy
                                                                })(
                                                                    <Input
                                                                        placeholder={'请输入'}
                                                                        autoComplete={'off'}
                                                                        disabled={data.credentialMode === 1 && data.credentialIdentified}
                                                                    />
                                                                )}
                                                            </CustomCol>
                                                        </CustomRow>
                                                        <CustomRow divider>
                                                            <CustomCol label="有效期" colStyle={{ width: '500px' }} required={getFieldValue('credentialIdentified') === 'true'}>
                                                                {getFieldDecorator('credentialValidDate', {
                                                                    rules: [{
                                                                        required: getFieldValue('credentialIdentified') === 'true', message: '请输入',
                                                                    }],
                                                                    initialValue: data.credentialValidDate1 && data.credentialValidDate2 ? [moment(data.credentialValidDate1), moment(data.credentialValidDate2)] : undefined
                                                                })(
                                                                    <RangePicker
                                                                        placeholder={['请输入有效期', '请输入有效期']}
                                                                        autoComplete={'off'}
                                                                        disabled={data.credentialMode === 1 && data.credentialIdentified}
                                                                    />
                                                                )}
                                                            </CustomCol>
                                                        </CustomRow>
                                                    </div>
                                                </div>
                                                <Row>
                                                    <Col>
                                                        <CustomRow divider>
                                                            <CustomCol label="人脸识别">
                                                                {getFieldDecorator('faceDetected', {
                                                                    rules: [{
                                                                        required: true, message: '请选择',
                                                                    }],
                                                                    initialValue: data.faceDetected === undefined ? "false" : data.faceDetected.toString()
                                                                })(
                                                                    <Select
                                                                        showSearch
                                                                        placeholder="请选择"
                                                                        optionFilterProp={'children'}
                                                                        disabled={data.faceDetectedMode === 1 && data.faceDetected}
                                                                    >
                                                                        <Option value="true">已认证</Option>
                                                                        <Option value="false">未认证</Option>
                                                                    </Select>
                                                                )}
                                                            </CustomCol>
                                                            <CustomCol label="认证方式">
                                                                {getFieldDecorator('faceDetectedMode', {
                                                                    rules: [{
                                                                        required: true, message: '请选择',
                                                                    }],
                                                                    initialValue: data.faceDetectedMode || 2
                                                                })(
                                                                    <Select
                                                                        showSearch
                                                                        placeholder="请选择"
                                                                        optionFilterProp={'children'}
                                                                        disabled
                                                                    >
                                                                        {authenticationStatus.map((item, index) => <Option value={item.value} key={item.value} title={item.title}>{item.title}</Option>)}
                                                                    </Select>
                                                                )}
                                                            </CustomCol>
                                                        </CustomRow>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    {
                                                        Array.isArray(data.attachList4)
                                                            ? data.attachList4.map((item, index) => {
                                                                return <Col key={index} span={3} style={{ textAlign: 'center', marginTop: '15px', marginLeft: index === 0 ? 0 : '15px' }}>
                                                                    <UploadFragment
                                                                        index={index}
                                                                        preview={item.attach_url || item.fileUrl}
                                                                        previewFn={(prevImg) => {
                                                                            this.setState({
                                                                                showPrevImg: true,
                                                                                prevImg
                                                                            })
                                                                        }}
                                                                        deleteFn={this.handleDeleteAttach.bind(this, 4)}
                                                                        show={!(data.faceDetectedMode === 1 && data.faceDetected)}
                                                                    />
                                                                </Col>
                                                            })
                                                            : null
                                                    }
                                                    {
                                                        !Array.isArray(data.attachList4) || data.attachList4.length < 4
                                                            ? data.faceDetectedMode === 1 && data.faceDetected
                                                                ? null
                                                                : <Col span={3} style={{ textAlign: 'center', marginTop: '15px', marginLeft: Array.isArray(data.attachList4) && data.attachList4.length ? '15px' : 0 }}>
                                                                    <Upload {...uploadEnclosure({ accept: 'image/*', tableName: 'customer', success: this.uploadEnclosure.bind(this, 4), attachType: 4 ,rowId:data.id||''})}>
                                                                        <div className="upload-box">
                                                                            <Icon type="plus" />
                                                                            <div className="ant-upload-text">人脸照</div>
                                                                        </div>
                                                                    </Upload>
                                                                </Col>
                                                            : null
                                                    }
                                                </Row>
                                                <Row>
                                                    <DetailTitle title="附件" />
                                                    <FileUpload hideLabel ref={(ref) => this.fileUploadRef = ref} tableName="customer" rowId={this.state.customerId} fileTypeList={[14]} />
                                                </Row>
                                            </TabPane>
                                            <TabPane tab="接口日志" key="4"> 
                                                { this.renderApiLog() }
                                            </TabPane>
                                        </Tabs>
                                    </div>
                                    : null
                        }
                    </Form>
                </div>
                <Modal
                    title="预览图片"
                    visible={this.state.showPrevImg}
                    footer={null}
                    onCancel={() => {
                        this.setState({
                            showPrevImg: false,
                            prevImg: ''
                        })
                    }}
                    width={800}
                    centered
                >
                    <div style={{ textAlign: 'center', maxWidth: '1000px', maxHeight: '600px', padding: '20px' }}>
                        <img src={this.state.prevImg} style={{ width:'100%' }} alt="" />
                    </div>
                </Modal>


                <ModalDom
                    title="日志详情"
                    visible={this.state.detailVisible}
                    loading={false}
                    width="660px"
                    onOk={this.handleOk}
                    footer={<Button onClick={this.handledetailCancel}>关闭</Button>}
                    onCancel={() => { this.setState({ detailVisible: false }) }}
                >
                    <Form>
                        <Form.Item {...formItemLayout} label="接口url">
                            {getFieldDecorator('url', {
                                initialValue: detailData.url
                            })(
                                <Input
                                    autoComplete={'off'}
                                />
                            )}
                        </Form.Item>
                        <Form.Item {...formItemLayout} label="接口参数">
                            {getFieldDecorator('params', {
                                initialValue: detailData.params
                            })(
                                <TextArea
                                    autoComplete={'off'}
                                />
                            )}
                        </Form.Item>
                        <Form.Item {...formItemLayout} label="接口返回值">
                            {getFieldDecorator('response', {
                                initialValue: detailData.response
                            })(
                                <TextArea
                                    autoComplete={'off'}
                                />
                            )}
                        </Form.Item>
                    </Form>
                </ModalDom>
            </ModalDom>
        </div>
    }

    
}

export default Form.create()(Page);


// WEBPACK FOOTER //
// ./src/page/Customer/components/ListAdd/index.js